import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Drawer from 'material-ui/Drawer';
import Graph from 'react-graph-vis';
import ZoomControl from 'components/ZoomControl';
import EdgeDetail from 'components/EdgeDetail';
import NodeDetail from 'components/NodeDetail';
import Hover from 'components/Hover';
import Menu from 'components/Menu';
import LoadHtml from 'components/LoadHtml';
import Header from 'components/Header';
import RightMenu from 'components/RightMenu';

import { drawerStatusChange, getEdges, getNodes, setDetail, infoDrawerStatusChange, getNodesByCountry, setNodes, closeIntro } from 'actions';

const CONFIG = require('../../../config.json');
const parse = require('url-parse');

export class Home extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = ({
      menuopened: false,
      htmlopened: false,
      nodes: [],
      options: {
        autoResize: true,
        width: '100%',
        height: '100%',
        interaction: {
          hover: true,
        },
        manipulation: {
          enabled: true,
        },
        nodes: {
          shape: 'dot',
          borderWidth: 4,
          size: 20,
          color: {
            border: CONFIG.colorBrownBorder,
            background: CONFIG.colorBrown,
            highlight: CONFIG.colorHighlight,
            hover: {
              border: CONFIG.colorHighlight,
              background: CONFIG.colorBrown,
            },
          },
          font: {
            multi: true,
            size: 12,
          },
          widthConstraint: {
            minimum: 150,
            maximum: 150,
          },
        },
        edges: {
          color: {
            highlight: CONFIG.colorHighlight,
            hover: CONFIG.colorHighlight,
          },
          length: 250,
          widthConstraint: {
            maximum: 200,
          },
        },
        physics: {
          barnesHut: {
            gravitationalConstant: -3000,
            centralGravity: 0.1,
            damping: 0.14,
            avoidOverlap: 0.02,
          },
          maxVelocity: 13,
          minVelocity: 0.43,
          timestep: 0.2,
          adaptiveTimestep: true,
          solver: 'barnesHut',
          stabilization: {
            enabled: true,
            iterations: 1500,
            fit: true,
          },
        },
      },
    });
    this.hoverNode = this.hoverNode.bind(this);
    this.blurNode = this.blurNode.bind(this);
    this.scaleIn = this.scaleIn.bind(this);
    this.scaleOut = this.scaleOut.bind(this);
    this.animateFit = this.animateFit.bind(this);
    this.handleTagClick = this.handleTagClick.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.handleFlagClick = this.handleFlagClick.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  static propTypes = {
    app: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  componentWillMount() {
    const { dispatch } = this.props;
    if (window.innerWidth <= 1000) {
      dispatch(drawerStatusChange(false));
    }
    dispatch(getEdges());
    dispatch(getNodes(''));
    window.network = this;
    this.handleSidebarClick = this.handleSidebarClick.bind(this);
    this.handleMenuClick = this.handleMenuClick.bind(this);
  }

  /**
   * Add event listener
   */
  componentDidMount() {
    this.onDrawFinished();
  }

  componentWillReceiveProps(nextProps) {
    const app = this.props.app;
    const nextapp = nextProps.app;
    if (app.nodes.data.length !== nextapp.nodes.data.length) {
      this.props = nextProps;
      this.onDrawFinished();
    }
    if (app.edges.data.length !== nextapp.edges.data.length) {
      this.props = nextProps;
      this.onDrawFinished();
    }
    if (app.tag !== nextapp.tag) {
      this.onDrawFinished();
    }
  }

  events = {
    select: function(event) {
      const { nodes, edges } = event;
      if (nodes.length>0) {
        window.network.showDetailPanel(nodes[0], 0);
      } else {
        window.network.showDetailPanel(edges[0], 1);
      }
    },
    afterDrawing: function() {
    }
  }

  onDrawFinished() {
    const { dispatch, app } = this.props;
    const edges = app.edges.data;
    const nodeid = this.props.match.params.nodeid;
    const edgeid = this.props.match.params.edgeid;
    const tag = this.props.match.params.tag;
    const country = this.props.match.params.country;

    if (edgeid) {
      dispatch(drawerStatusChange(true));
      dispatch(setDetail({ nodeid: 0, edgeid: edgeid }));
      try {
        const network = this._network;
        setTimeout(function(){
          network.selectEdges([edgeid]);
          let filtered_nodes = [];
          let nodes = app.nodes.data;
          const connected_nodes = network.getConnectedNodes(edgeid);
          for(let node of nodes){
            const node_id = node.id;
            if( connected_nodes.indexOf(node_id) !== -1 || nodeid==node_id) {
              filtered_nodes.push(node);
            }
          }
          if(filtered_nodes.length>0){
            network.setData({
              nodes: filtered_nodes,
              edges: edges,
            });
          }
        }, 3000);
      } catch (e) {
        console.error(e);
      }
    } else if (nodeid) {
      dispatch(drawerStatusChange(true));
      dispatch(setDetail({ nodeid, edgeid: 0 }));
      try {
        const network = this._network;
        setTimeout(function(){
          let filtered_nodes = [];
          let nodes = app.nodes.data;
          const connected_nodes = network.getConnectedNodes(nodeid);
          for(let node of nodes){
            const node_id = node.id;
            if( connected_nodes.indexOf(node_id) !== -1 || nodeid==node_id) {
              filtered_nodes.push(node);
            }
          }
          
          if(filtered_nodes.length>0){
            network.setData({
              nodes: filtered_nodes,
              edges: edges,
            });
            network.selectNodes([nodeid], true);
          }
        }, 3000);
      } catch (e) {
        console.log(e);
      }
    } else if (tag) {
      dispatch(infoDrawerStatusChange(true));
      dispatch(getNodes(tag));
      this._network.setData({
        nodes: this.props.app.nodes.data,
        edges: this.props.app.edges.data,
      });
      const nodes = this.filterNodes(this.props.app.nodes.data);
      this._network.setData({
        nodes,
        edges: this.props.app.edges.data,
      });
      this._network.redraw();
    } else if (country) {
      dispatch(getNodesByCountry(country));
      this._network.setData({
        nodes: this.props.app.nodes.data,
        edges: this.props.app.edges.data,
      });
      const nodes = this.filterNodes(this.props.app.nodes.data);
      this._network.setData({
        nodes,
        edges: this.props.app.edges.data,
      });
      this._network.redraw();
    } else {
      this._network.setData({
        nodes: this.props.app.nodes.data,
        edges: this.props.app.edges.data,
      });
      this._network.redraw();
    }

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    } else {
      this._network.on('hoverNode', this.hoverNode);
    }
    this._network.on('blurNode', this.blurNode);
  }

  filterNodes(nodes) {
    const result = [];
    for (const node of nodes) {
      const connected_nodes = this._network.getConnectedNodes(node.id);
      if (connected_nodes.length > 0) {
        result.push(node);
      }
    }
    this.setState({ nodes: result });
    return result;
  }

  hoverNode(params) {
    this.showHoverPanel(params);
  }

  blurNode() {
    this.setState({ showHover: false });
  }

  showHoverPanel(params) {
    const id = params.node;
    const { app } = this.props;
    const nodes = app.nodes.data;
    for (const node of nodes) {
      if (node.id === id) {
        this.setState({ selectedNode: node, showHover: true, x: params.event.clientX, y: params.event.clientY });
      }
    }
  }

  showDetailPanel(id, type) {
    if (id) {
      window.nodeorlink = true;
    }
    this.setState({ htmlopened: false });
    const { dispatch } = this.props;
    dispatch(drawerStatusChange(true));
    dispatch(infoDrawerStatusChange(false));
    const { app } = this.props;
    const nodes = app.nodes.data;
    const edges = app.edges.data;
    if (type === 0) {
      for (const node of nodes) {
        if (node.id === id) {
          dispatch(setDetail({ nodeid: id, edgeid: 0 }));
          this.props.history.push('/node/'+id);
        }
      }
    } else if (type === 1) {
      for (const edge of edges) {
        if (edge.id === id) {
          dispatch(setDetail({ nodeid: edge.from, edgeid: id }));
          this.props.history.push('/edge/'+id);
        }
      }
    } else {
      dispatch(setDetail({ nodeid: 0, edgeid: 0 }));
      this.props.history.push('/');
    }
  }

  getNetwork(network) {
    this._network = network;
  }

  animateFit() {
    const network = this._network;
    const options = { offset: { x: 0, y: 0 },
      duration: 1000,
      easingFunction: 'linear',
    };
    network.fit({ animation: options });
  }

  scaleIn() {
    const network = this._network;
    const scale = network.getScale();
    const options = {
      position: { x: 0, y: 0 },
      scale: scale * 1.5,
      offset: { x: 0, y: 0 },
      animation: true,
    };
    network.moveTo(options);
  }

  scaleOut() {
    const { dispatch } = this.props;
    dispatch(getEdges());
    const network = this._network;
    const scale = network.getScale();
    const options = {
      position: { x: 0, y: 0 },
      scale: scale / 1.5,
      offset: { x: 0, y: 0 },
      animation: true,
    };
    network.moveTo(options);
  }

  handleMenuClick() {
    this.setState({ menuopened: !this.state.menuopened });
  }

  handleSidebarClick() {
    const { tag } = this.props.app;
    if (tag) {
      this.setState({ htmlopened: !this.state.htmlopened });
    }
  }

  handleTagClick(tag) {
    const { dispatch } = this.props;
    dispatch(getNodes(tag.tag));
    dispatch(drawerStatusChange(false));
    dispatch(infoDrawerStatusChange(true));
    this.props.history.push('/tags/'+tag.tag);
  }

  handleFilter(tag) {
    const { app, dispatch } = this.props;
    dispatch(drawerStatusChange(false));
    dispatch(getNodes(tag));
    dispatch(closeIntro());
    this.props.history.push('/tags/'+tag);
  }

  htmlopen(selectedTag) {
    const { app } = this.props;
    if (selectedTag === 'qatar-charity') {
      if (app.infodraweropened && !app.isfirstvisit) {
        return true;
      }
      return false;
    }
    return app.infodraweropened;
  }

  gotoHome() {
    const { dispatch } = this.props;
    this.props.history.push('/');
    dispatch(drawerStatusChange(false));
    dispatch(infoDrawerStatusChange(false));
  }

  handleFlagClick(country) {
    const { app } = this.props;
    const nodes = app.nodes.data;
    const selected_nodes = [];
    if (country === 'brotherhood') {
      const findNodes = this._network.findNode(48);
      if (findNodes.length > 0) {
        selected_nodes.push(48);
      }
    } else {
      for (const node of nodes) {
        let node_country = node.country+'';
        node_country = node_country.toLowerCase();
        if (node_country === country.toLowerCase()) {
          const findNodes = this._network.findNode(node.id);
          if (findNodes.length > 0) {
            selected_nodes.push(node.id);
          }
        }
      }
    }
    const network = this._network;
    network.selectNodes(selected_nodes, true);
  }

  handleMouseOut() {
    this._network.selectNodes([], true);
  }

  onSelectNode(nodeid) {
    const { app, dispatch } = this.props;
    dispatch(drawerStatusChange(true));
    dispatch(infoDrawerStatusChange(false));
    const nodes = app.allnodes.data;
    const network = this._network;
    network.setData({
      nodes,
      edges: app.edges.data,
    });
    for (const node of nodes) {
      if (node.id === nodeid) {
        const filtered_nodes = [];
        const connected_nodes = network.getConnectedNodes(nodeid);
        for (const nodeitem of nodes) {
          const node_id = nodeitem.id;
          if (connected_nodes.indexOf(node_id) !== -1 || nodeid === node_id) {
            filtered_nodes.push(nodeitem);
          }
        }
        if (filtered_nodes.length > 0) {
          network.setData({
            nodes: filtered_nodes,
            edges: app.edges.data,
          });
          network.selectNodes([nodeid], true);
          dispatch(setNodes({ filtered_nodes }));
          dispatch(setDetail({ nodeid, edgeid: 0 }));
          this.props.history.push('/node/'+nodeid);
        }
      }
    }
  }

  handleHTMLClick(event) {
    event.preventDefault();
    const el = event.target;
    const url = parse(el.href);
    if (el.href) {
      if (location.origin === url.origin) {
        this.props.history.push(url.pathname);
        let split = url.pathname;
        split = split.split('/');
        if (split[1] === 'tags') {
          this.handleFilter(split[2]);
        } else {
          const nodeid = split[split.length-1];
          this._network.selectNodes([nodeid], true);
        }
      } else {
        window.open(el.href, '_new');
      }
    }
  }

  onClick() {
    if (window.nodeorlink) {
      window.nodeorlink = false;
    } else {
      const { dispatch } = this.props;
      dispatch(drawerStatusChange(false));
      dispatch(infoDrawerStatusChange(false));
    }
  }

  render() {
    const { app, dispatch } = this.props;
    const nodes = app.nodes.data;
    const edges = app.edges.data;
    const selectedTag = app.tag;
    function isEmpty(obj) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false;
        }
      }
      return true;
    }
    //Graph
    const graph = {
      nodes,
      edges,
    };
    let selectedNode = {};
    let selectedEdge = {};
    const selectInfo = app.info.data;
    if (!isEmpty(selectInfo)) {
      for (const node of nodes) {
        if (node.id+'' === selectInfo.nodeid+'') {
          selectedNode = node;
        }
      }
      for (const edge of edges) {
        if (edge.id+'' === selectInfo.edgeid+'') {
          selectedEdge = edge;
        }
      }
    }

    return (
      <div>
        <Header gotoHome={() => this.gotoHome()} handleFilterClick={(tag) => this.handleFilter(tag)} onSelectNode={(nodeid) => this.onSelectNode(nodeid)} />
        <RightMenu handleItemClick={(flag) => this.handleFlagClick(flag)} handleMouseOut={() => this.handleMouseOut()} />
        <Menu isopen={this.state.menuopened} handleCloseClick={() => this.setState({ menuopened: false })} handleFilterClick={(tag) => this.handleFilter(tag)} />
        <LoadHtml isopen={this.htmlopen(selectedTag)} handleCloseClick={() => dispatch(infoDrawerStatusChange(false))} tag={selectedTag} handleHTMLClick={(event) => this.handleHTMLClick(event)} />
        {
          (!isEmpty(selectedNode) || !isEmpty(selectedEdge)) && (
            <Drawer open={app.draweropened} className="left-drawer" type="persistent">
              <div>
                {
                  (!isEmpty(selectedEdge)) ?
                    (
                      <EdgeDetail handleCloseDetailClick={() => dispatch(drawerStatusChange(false))} edge={selectedEdge} nodes={nodes} />
                    )
                    :
                    (
                      <NodeDetail handleCloseDetailClick={() => dispatch(drawerStatusChange(false))} handleTagClick={(tag) => this.handleTagClick(tag)} node={selectedNode} />
                    )
                }
              </div>
            </Drawer>
          )
        }

        <div className="right-panel">
          <div className="zoom-panel">
            <ZoomControl handleInClick={this.scaleIn} handleOutClick={this.scaleOut} handleFitClick={this.animateFit} />
          </div>
          <div onClick={this.onClick}>
            <Graph graph={graph} options={this.state.options} events={this.events} style={{ height: '100vh' }} getNetwork={(network) => this.getNetwork(network)} />
          </div>
        </div>
        {
          (this.state.showHover) ?
            (
              <Hover handleCloseDetailClick={() => this.setState({ showHover: false })} node={this.state.selectedNode} top={this.state.y} left={this.state.x} />
            ) : (<div />)
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return { app: state.app };
}

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./scripts/routes/Home.jsx